export const LOADING_GENERAL_DATA = "LOADING_GENERAL_DATA";
export const SAVE_LOADING_GENERAL_DATA = "SAVE_GENERAL_DATA";
export const GET_GENERAL_DATA = "GET_GENERAL_DATA";
export const FORM_FAIL = "FORM_FAIL";
export const FORM_FAIL_JSON = "FORM_FAIL_JSON";
export const GENERAL_DATA_FAIL = "GENERAL_DATA_FAIL";
export const LOADING_GENERAL_DATA_BY_ID = "LOADING_GENERAL_DATA_BY_ID";
export const GET_GENERAL_DATA_BY_ID = "GET_GENERAL_DATA_BY_ID";